module.exports = __webpack_public_path__ + "static/img/benjyfishy.d79508e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/coach/benjyfishy.png
// module id = 9v/2
// module chunks = 38